import PropTypes from 'prop-types';
import { useContext } from 'react';
import MyAccountLayoutDesktop from './MyAccountLayoutDesktop';
import MyAccountLayoutMobile from './MyAccountLayoutMobile';
import { isMobile } from '../../services/DeviceInformation';
import NavigationTabs from '../../constants/NavigationTabs';
import Loading from '../Loading';
import LoadingScreenContext from '../../services/LoadingScreenContext';

function MyAccountLayout({ children, selectedTab }) {
    const { loading } = useContext(LoadingScreenContext);

    if (isMobile()) {
        return (
            <MyAccountLayoutMobile selectedTab={selectedTab}>
                {loading && <Loading />}
                {children}
            </MyAccountLayoutMobile>
        );
    }
    return (
        <MyAccountLayoutDesktop selectedTab={selectedTab}>
            {loading && <Loading />}
            {children}
        </MyAccountLayoutDesktop>
    );
}

MyAccountLayout.propTypes = {
    children: PropTypes.node,
    selectedTab: PropTypes.oneOf([
        NavigationTabs.HOME,
        NavigationTabs.GENERAL,
        NavigationTabs.EMAILS,
        NavigationTabs.CHANGE_PASSWORD,
    ]),
};

export default MyAccountLayout;
